import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as S from "./styles"; // Import your styles

const PaymentInfo = () => {
  const navigate = useNavigate();
  const [cardNumber, setCardNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [cvv, setCvv] = useState("");

  const handleNext = () => {
    // Validate the payment information
    // If everything is valid, navigate to the next step
    navigate("/order-review");
  };

  return (
    <S.Container>
      <S.Content>
        <S.Heading>Enter Payment Information</S.Heading>
        <S.Form>
          <S.Input
            type="text"
            placeholder="Card Number"
            value={cardNumber}
            onChange={(e) => setCardNumber(e.target.value)}
          />
          <S.Input
            type="text"
            placeholder="Expiry Date"
            value={expiryDate}
            onChange={(e) => setExpiryDate(e.target.value)}
          />
          <S.Input
            type="text"
            placeholder="CVV"
            value={cvv}
            onChange={(e) => setCvv(e.target.value)}
          />
          <S.Button onClick={handleNext}>Next</S.Button>
        </S.Form>
      </S.Content>
    </S.Container>
  );
};

export default PaymentInfo;
